/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_Language_PlaceholderInputs */

const en_audio_embed_export_output_language_placeholder = /** @type {(inputs: Audio_Embed_Export_Output_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. eng`)
};

const fr_audio_embed_export_output_language_placeholder = /** @type {(inputs: Audio_Embed_Export_Output_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par exemple eng`)
};

const de_audio_embed_export_output_language_placeholder = /** @type {(inputs: Audio_Embed_Export_Output_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. eng`)
};

const it_audio_embed_export_output_language_placeholder = /** @type {(inputs: Audio_Embed_Export_Output_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ad esempio inglese`)
};

const ru_audio_embed_export_output_language_placeholder = /** @type {(inputs: Audio_Embed_Export_Output_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, eng`)
};

const es_audio_embed_export_output_language_placeholder = /** @type {(inputs: Audio_Embed_Export_Output_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p. ej. inglés`)
};

const zh_cn2_audio_embed_export_output_language_placeholder = /** @type {(inputs: Audio_Embed_Export_Output_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 eng`)
};

const ja_audio_embed_export_output_language_placeholder = /** @type {(inputs: Audio_Embed_Export_Output_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例：英語`)
};

const hi_audio_embed_export_output_language_placeholder = /** @type {(inputs: Audio_Embed_Export_Output_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उदाहरण के लिए, अंग्रेजी`)
};

const pt_pt2_audio_embed_export_output_language_placeholder = /** @type {(inputs: Audio_Embed_Export_Output_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por exemplo, eng`)
};

/**
* | output |
* | --- |
* | "e.g. eng" |
*
* @param {Audio_Embed_Export_Output_Language_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_language_placeholder = /** @type {((inputs?: Audio_Embed_Export_Output_Language_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_Language_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_output_language_placeholder(inputs)
	if (locale === "de") return de_audio_embed_export_output_language_placeholder(inputs)
	if (locale === "it") return it_audio_embed_export_output_language_placeholder(inputs)
	if (locale === "ru") return ru_audio_embed_export_output_language_placeholder(inputs)
	if (locale === "es") return es_audio_embed_export_output_language_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_output_language_placeholder(inputs)
	if (locale === "ja") return ja_audio_embed_export_output_language_placeholder(inputs)
	if (locale === "hi") return hi_audio_embed_export_output_language_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_output_language_placeholder(inputs)
	return en_audio_embed_export_output_language_placeholder(inputs)
});